import WhyDocumentServices from "../../../../src/pages/enterprise/why-document-services.md";
import SeamlessAndSimpleIntegration from "../../../../src/pages/enterprise/Seamless_sample_integration.md";
import ReimagineYourDocument from "../../../../src/pages/enterprise/Reimagine_your_document.md";
import CustomerStory from "../../../../src/pages/enterprise/customStories.md";
import { APIPixelRetargeting } from "../../../../src/components/retargetting";
import * as React from 'react';
export default {
  WhyDocumentServices,
  SeamlessAndSimpleIntegration,
  ReimagineYourDocument,
  CustomerStory,
  APIPixelRetargeting,
  React
};